"use strict";

var bookingHub = new signalR.HubConnectionBuilder().withUrl("/bookingHub").build();
var $bookingHubStarted = new Promise((resolve, reject) => {
    bookingHub.start().then(function (data) {
        resolve();
    }).catch(function (err) {
        console.log(err);
        reject(err);
    });
});

$(function () {
    $.ajaxSetup({
        beforeSend: function (xhr) {
            xhr.setRequestHeader("Timezone", new Date().getTimezoneOffset());
            xhr.setRequestHeader("contentType", "application/json");
        }
    });

    $(document).ajaxStart(function () {
        $("#ajaxing").show();
    });

    $(document).ajaxError(function (event, xhr) {
        if ((xhr.status === 302 || xhr.status === 403) && xhr.getResponseHeader("clt") === "true") {
            window.location.href = "/account/login?clt=true";
        }
    });

    $(document).ajaxComplete(function () {
        $("#ajaxing").hide();
    });

    bookingHub.off("LoginUser");
    bookingHub.on("LoginUser", function (clt) {
        if (clt === Cookies.get("clt")) {
            window.location.href = "/account/login?clt=true";
        }
    });

    registerPasswordCreationListener();
});

function registerPasswordCreationListener() {
    $(".js-toggle-password").click(function () {
        var currentType = $(this).siblings("input").attr("type");
        var newType = currentType === "password" ? "text" : "password";
        $(this).siblings("input").attr("type", newType);
    });
}

function BookingTimer(timerElementId, uniqueId, link, countdown, reservedUntil, totalTimeElementId) {

    var countDown = countdown;

    var countDownTimer;
    var uniqueId = uniqueId;
    var link = link;

    var cookieTimer = Cookies.get(uniqueId);
    if (typeof (cookieTimer) == "undefined") {
        var now = new Date();
        Cookies.set(uniqueId, new Date(now.getTime() + countDown * 1000));
    } else {
        var endTime = new Date(cookieTimer);
        var startTime = new Date();
        var difference = endTime.getTime() - startTime.getTime();
        if (difference > 0) {
            var resultInSeconds = Math.round(difference / 1000);
            countDown = resultInSeconds;
        }
        else {
            countDown = 0;
            $(totalTimeElementId).html(Math.floor(countDown / 60) + ' minutes.');
            $(timerElementId).html(Math.floor(countDown / 60) + ':' + zeroPad((countDown % 60), 2));
            $("#confirm-review-button").remove();
            $("#cancel-review-button").remove();
            $("#pick-new-timeslot-button").removeAttr("hidden");
            $("#time-remaining").css("color", "red");
            return;
        }
    }

    if (countDownTimer) {
        window.clearInterval(countDownTimer);
    }

    var minutes = Math.floor(countdown / 60);
    var minutesText = " minute.";
    if (minutes > 1) {
        minutesText = " minutes.";
    }
    $(totalTimeElementId).html(minutes + minutesText);

    refreshCountdown();
    var refreshId = countDownTimer = setInterval(() => {
        countDown--;
        refreshCountdown();
    }, 1000);

    function refreshCountdown() {
        if (countDown <= 0) {
            window.clearInterval(countDownTimer);
            expiredReservation();
        }

        $(timerElementId).html(Math.floor(countDown / 60) + ':' + zeroPad((countDown % 60), 2));
    }

    function expiredReservation() {
        var data = {
            link: link,
            action: 'expired',
            timeSlot: '',
            uniqueId: uniqueId
        };

        $.ajax({
            url: '/api/Booking',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                $("#confirm-review-button").remove();
                $("#cancel-review-button").remove();
                $("#pick-new-timeslot-button").removeAttr("hidden");
                $("#time-remaining").css("color", "red");
            }
        });
    }
}

function timezoneOffsetToUtcString(offset) {
    var sign = (offset >= 0) ? "+" : "-";
    var hours = zeroPad(Math.floor(Math.abs(offset) / 60), 2);
    var minutes = zeroPad(Math.abs(offset) % 60, 2);
    return "UTC" + sign + hours + ":" + minutes;
}

function zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
}


function AvailabilitySearch(criteria, uniqueId, sourceId, calendarElementId, noTimeSelectedElementId, currentTimeslot) {
    var availabilityMatrix;
    var selection;

    $(function () {
        $.ajax({
            url: '/api/Availability',
            type: 'POST',
            data: JSON.stringify(criteria),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                availabilityMatrix = _.groupBy(response, "timeSlotDateString");
                var fromDate = new Date(criteria.from);

                initCalendar(fromDate);

            }
        });
    });

    function getWeek(startDate) {

        var week = [];
        for (var j = 0; j < 7; j++) {
            var dateStringified = startDate.addDays(j).toISOString().split('T', 1)[0];
            var dayAvailability = [];
            if (availabilityMatrix[dateStringified]) {
                dayAvailability = availabilityMatrix[dateStringified].map(function (d) { return { numberOfResources: d.numberOfResources, timeSlotId: d.timeSlotId, timeSlotStartHourUtc: d.timeSlotStartHour, timeSlotStartHour: d.timeSlotStartCandidateHourString, timeSlotEndHour: d.timeSlotEndCandidateHourString }; })
            }
            week.push(dayAvailability);
        }

        return week;
    }

    function initCalendar(startDate) {

        var initialAvailability = getWeek(startDate);

        var options = {
            startDate: startDate,
            availability: initialAvailability,
            isMultiple: false,
            onClick: function (ev, startDate, data) {
                selection = data;
                $(noTimeSelectedElementId).hide();
                executeTimeSlotAction(rebook == 'True' ? 'rebook' : 'reserve', uniqueId, sourceId);
            },
            onClickNavigator: function (ev, startDate, instance) {
                instance.setAvailability(getWeek(new Date(startDate)));
            }
        };

        $(calendarElementId).markyourcalendar(options, currentTimeslot);
    }

    function executeTimeSlotAction(action, id, sourceId) {
        var data = {
            action: action,
            timeSlot: selection[0],
            uniqueId: id,
            assignEvaluator: true
        };

        $.ajax({
            url: '/api/Booking',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: () => {
                bookingHub.invoke("UpdateBooking", data.uniqueId).catch(function (err) {
                    return console.error(err.toString());
                });

                window.location.href = '/Booking/Review?uid=' + uniqueId + '&sourceId=' + sourceId;
            }
        });
    }
}

function Candidate(timezoneSelectId) {
    var timezoneOffset = new Date().getTimezoneOffset();
    $(timezoneSelectId).val(timezoneOffset);
}

function Localizer() {
    const localizer = localStorage.getItem('localizer');
    const localizerAsJson = localizer && JSON.parse(localizer);
    const appVersion = $('html').data('appVersion');

    if (localizerAsJson && localizerAsJson["cacheBuster"] === appVersion) {
        this.localizer = localizerAsJson;
    }
    else {
        this.localizer = {};

        const r1 = $.getJSON('/resx/fr.json');
        const r2 = $.getJSON('/resx/en.json');

        $.when(r1, r2).done((d1, d2) => {
            this.localizer["1"] = d1[0];
            this.localizer["2"] = d2[0];
            this.localizer["cacheBuster"] = appVersion;
            localStorage.setItem('localizer', JSON.stringify(this.localizer));
        });
    }

    this.getCurrentIso2Lang = function () {

        var possibleLang = document.cookie.match(new RegExp('(^| )' + '.AspNetCore.Culture' + '=([^;]+)'));
        var cookie = "EN";
        if (possibleLang != null) {

            cookie = possibleLang[2].match(new RegExp('[a-z]{2}'))[0];
            cookie = cookie.toUpperCase();
        }
        return cookie && cookie.toLowerCase() || 'en';
    };

    this.getKey = (key) => {
        return unicodeToChar(this.localizer[getCurrentLang()][key]);
    }
}

function getCurrentLang() {
    var possibleLang = document.cookie.match(new RegExp('(^| )' + '.AspNetCore.Culture' + '=([^;]+)'));
    var cookie = "EN";
    if (possibleLang != null) {

        cookie = possibleLang[2].match(new RegExp('[a-z]{2}'))[0];
        cookie = cookie.toUpperCase();
    }
    var langId = cookie == "EN" ? "2" : "1";
    return langId;
}

function unicodeToChar(text) {
    return text.replace(/\\u[\dA-F]{4}/gi,
        function (match) {
            return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
        });
}

function padMinutes(value) {
    return value < 10 ? "0" + value : value;
}

Object.filter = (obj, predicate) => Object.fromEntries(Object.entries(obj).filter(predicate));

var globalLocalizer = new Localizer();